export const getOutputString = (output: string) => {
  return output.replace(/   /g, '\n')
}
